import { RouterLink as RouterLinkType } from './types/RouterLink';
import { Role } from './types/Role';

export enum routeUrls {
    DASHBOARD = '/dashboard',
    COCKPIT = '/cockpit',
    USERMANAGEMENT = '/gebruikersbeheer',
    SUBMISSIONS = '/aanvragen',
    CHANGE_REQUESTS = '/status-aanvragen',
}

export const routes = [
    { title: 'Dashboard', path: routeUrls.DASHBOARD, accessLevel: Role.USER },
    { title: 'Cockpit', path: routeUrls.COCKPIT, accessLevel: Role.ADMIN },
    { title: 'Gebruikersbeheer', path: routeUrls.USERMANAGEMENT, accessLevel: Role.ADMIN },
    { title: 'Aanvragen', path: routeUrls.SUBMISSIONS, accessLevel: Role.ADMIN },
    { title: 'Status aanvragen', path: routeUrls.CHANGE_REQUESTS, accessLevel: Role.USER, visibility: Role.USER },
] as RouterLinkType[];
